import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { C } from '@/theme/tokens';

export interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  /** Adds a soft permanent gold glow even when not hovered. */
  glow?: boolean;
}

/**
 * Bordered card with a gold/bronze top accent strip and a hover-glow border.
 * Used by feature pillars, GM tools, backer tiers, and the reserve CTA card.
 */
export function Card({ children, style = {}, glow = false }: CardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: C.bgCard,
        border: `1px solid ${hovered ? C.gold : C.bronze}`,
        borderRadius: 5,
        boxShadow: hovered
          ? '0 0 30px rgba(212,175,55,0.25)'
          : glow
            ? '0 0 20px rgba(212,175,55,0.15)'
            : '0 0 20px rgba(0,0,0,0.3)',
        transition: 'all 0.2s',
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: 'linear-gradient(to right,#D4AF37,#C19A6B)',
        }}
      />
      {children}
    </div>
  );
}
